import { type PropsWithChildren } from 'react';

export const Chart = ({ children }: PropsWithChildren) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  (<>{children}</>)
);

Chart['displayName'] = 'MeterBarLayout.Chart';
